import { useState } from 'react';
import { FormControl, FormLabel, Stack, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import BooleanToggle from '@/components/forms/new/formikFormFields/BooleanToggle';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import walkthroughIds from '../../walkthroughIds';
import {
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const EnabledToggle = ({
    section,
    submitData,
    setPlatformNumber,
    darkMode,
    platformID,
    trunkList,
    isChecked,
    setIsChecked,
    setSelectedTrunk,
    isService = false,
    isTrunkDisabled = false,
    isCurrentTrunkOC = false,
}) => {
    const { editNumbersGeneral } = walkthroughIds;
    const [isHovered, setIsHovered] = useState(false);
    const [isAssignmentHovered, setIsAssignmentHovered] = useState(false);
    const platformIndex = submitData?.findIndex(
        (platform) => platform?.platformID === platformID,
    );
    const platform = submitData[platformIndex];
    const isLocked = platform?.isLockedForAssignment ?? false;
    const isEffectivelyEnabled = isChecked && !isTrunkDisabled;

    const handleSelectChange = (toggle) => {
        setIsChecked(toggle);
        if (toggle === false) {
            setPlatformNumber((prev) => {
                const newPlatformNumbers = [...prev];
                newPlatformNumbers[platformIndex] = {
                    ...platform,
                    trunkID: null,
                    operatorConnectCallingProfileID: null,
                    operatorConnectUsageID: null,
                };
                return newPlatformNumbers;
            });
            setSelectedTrunk(null);
        } else {
            setPlatformNumber((prev) => {
                const newPlatformNumbers = [...prev];
                isService
                    ? (newPlatformNumbers[platformIndex] = {
                          ...platform,
                          serviceID: trunkList?.[0]?.id || null,
                          isLockedForAssignment: false,
                      })
                    : (newPlatformNumbers[platformIndex] = {
                          ...platform,
                          trunkID: trunkList?.[0]?.id || null,
                          operatorConnectCallingProfileID: !isCurrentTrunkOC
                              ? null
                              : platform?.operatorConnectCallingProfileID,
                          operatorConnectUsageID: !isCurrentTrunkOC
                              ? null
                              : platform?.operatorConnectUsageID,
                          isLockedForAssignment: false,
                      });
                return newPlatformNumbers;
            });
            setSelectedTrunk(trunkList?.[0] || null);
        }
    };

    const handleAssignmentChange = (toggle) => {
        setPlatformNumber((prev) => {
            const newPlatformNumbers = [...prev];
            newPlatformNumbers[platformIndex] = {
                ...platform,
                isLockedForAssignment: !toggle,
            };
            return newPlatformNumbers;
        });
    };

    return (
        <FormControl sx={{ margin: '0 !important' }}>
            <Stack direction="row" sx={{ ...stackStyling(), width: '740px' }}>
                <Box
                    width={190}
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Enabled
                    </FormLabel>
                </Box>
                <Box
                    flex={1}
                    paddingTop="22px"
                    position="relative"
                    onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}>
                    <Field
                        component={BooleanToggle}
                        id={`${section}-enabled-toggle`}
                        name={`${section}-enabled-toggle`}
                        isChecked={isChecked}
                        onChange={handleSelectChange}
                        isDisabled={isTrunkDisabled}
                        walkthroughId={editNumbersGeneral.ufEnabledToggle}
                    />
                    {isHovered && (
                        <FieldToolTip
                            label={`Enable or disable current platform${isTrunkDisabled ? '. A platform can only be enabled if a trunk is defined' : ''}`}
                            ariaLabel="html-body-toggle-tip"
                            left="25px"
                            bottom="5px"
                        />
                    )}
                </Box>
                <Box
                    width={190}
                    onMouseEnter={() => setIsAssignmentHovered(true)}
                    onMouseLeave={() => setIsAssignmentHovered(false)}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Available for assignment
                    </FormLabel>
                </Box>
                <Box
                    flex={1}
                    paddingTop="22px"
                    position="relative"
                    onMouseEnter={() => setIsAssignmentHovered(true)}
                    onMouseLeave={() => setIsAssignmentHovered(false)}>
                    <Field
                        component={BooleanToggle}
                        id={`${section}-assignment-toggle`}
                        name={`${section}-assignment-toggle`}
                        isChecked={isEffectivelyEnabled ? !isLocked : false}
                        onChange={handleAssignmentChange}
                        isDisabled={!isEffectivelyEnabled}
                        walkthroughId={editNumbersGeneral.ufEnabledToggle}
                    />
                    {isAssignmentHovered && (
                        <FieldToolTip
                            label="Choose if this number can be assigned to a platform user or service account. Locked numbers cannot be assigned."
                            ariaLabel="assignment-toggle-tip"
                            left="25px"
                            bottom="5px"
                        />
                    )}
                </Box>
            </Stack>
        </FormControl>
    );
};

export default EnabledToggle;
